// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filters-panel {
  background: #b48a3a;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  color: #23232b;
}
.filter-row {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 0.5rem;
}
input[type="text"], input[type="number"], input[type="date"] {
  padding: 0.3rem 0.7rem;
  border-radius: 4px;
  border: none;
}
button {
  background: #23232b;
  color: #fff;
  border: none;
  padding: 0.4rem 1rem;
  border-radius: 5px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/failed-payments-management/failed-payments-filters.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".filters-panel {\n  background: #b48a3a;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  color: #23232b;\n}\n.filter-row {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\ninput[type=\"text\"], input[type=\"number\"], input[type=\"date\"] {\n  padding: 0.3rem 0.7rem;\n  border-radius: 4px;\n  border: none;\n}\nbutton {\n  background: #23232b;\n  color: #fff;\n  border: none;\n  padding: 0.4rem 1rem;\n  border-radius: 5px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
